export default __webpack_public_path__ + "static/investorpresentation-fdf4e2b9963f5b52c5d65cdd0fbc50de.jpg";